import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { COLOR_GREY_LIGHT } from '../../../vars';
import { fetchCompany } from '../actions';
import { selectCompany } from '../selectors';
import { Loader } from '../../../components/Loader';
import cn from 'classnames';
import styles from './CompanyCreateInfoCard.module.css';

const CardContainer = styled.div`
  min-width: 450px;
  margin: 10px 0 10px 24px;
  padding: 24px 24px;
  background-color: #f1f2fe;
  color: var(--color-new-grey-hover);
  font-weight: 600;
  border-radius: 0.375rem;
  h2 {
    font-size: 14px;
    text-transform: uppercase;
  }
`;

const CardInfoList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    display: flex;
    justify-content: space-between;
    padding: 15px 50px 15px 24px;
    border-bottom: 3px solid #fff;
    text-transform: capitalize;

    .value {
      width: 40%;
    }
  }
  li:hover {
    border-bottom: 3px solid #0183d5;
  }
`;

class CompanyCreateInfoCard extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  componentDidMount() {
    if (!this.props.createdCompany) {
      this.props.fetch();
    }
  }

  render() {
    if (!this.props.createdCompany) return <Loader small="true" />;
    return (
      <CardContainer className={styles.container}>
        <h2 className="mb-2">Company data</h2>
        <CardInfoList>
          {this.props.data.map(
            data_item =>
              this.props.createdCompany[data_item] && (
                <li className={styles.listItem} key={data_item}>
                  <span>{this.lbl(`vehicle.create.${data_item}`)}</span>
                  <span className="value">
                    {this.props.createdCompany[data_item] === 'company'
                      ? this.lbl(`company.property.company_type.company`)
                      : this.props.createdCompany[data_item] === 'individual'
                      ? this.lbl(`company.property.company_type.individual`)
                      : this.props.createdCompany[data_item]}
                  </span>
                </li>
              ),
          )}
        </CardInfoList>
      </CardContainer>
    );
  }
}

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    createdCompany: selectCompany(ownProps.company_id),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchCompany(ownProps.company_id));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyCreateInfo = compose(withConnect, withRouter)(CompanyCreateInfoCard);
